import { lazy } from 'react';

// Route pages load only when visited; the router retains its existing paths and guards.
export const LearnPlaygroundPage = lazy(() =>
  import('@/pages/learn/playground/LearnPlaygroundPage').then((module) => ({
    default: module.LearnPlaygroundPage,
  })),
);

export const EngineSandboxDevPage = lazy(() =>
  import('@/pages/learn/playground/EngineSandboxDevPage').then((module) => ({
    default: module.EngineSandboxDevPage,
  })),
);

export const NotificationCenterPage = lazy(() =>
  import('@/pages/portal/NotificationCenterPage').then((module) => ({
    default: module.NotificationCenterPage,
  })),
);

export const AuditProjectPage = lazy(() =>
  import('@/pages/portal/AuditProjectPage').then((module) => ({
    default: module.AuditProjectPage,
  })),
);

export const BillingPage = lazy(() =>
  import('@/pages/portal/BillingPage').then((module) => ({ default: module.BillingPage })),
);

export const ChallengeHubRoute = lazy(() =>
  import('@/pages/portal/challenge/ChallengeHubRoute').then((module) => ({
    default: module.ChallengeHubRoute,
  })),
);

export const ChallengeRegisterPage = lazy(() =>
  import('@/pages/portal/challenge/ChallengeRegisterPage').then((module) => ({
    default: module.ChallengeRegisterPage,
  })),
);

export const ChallengeReportPage = lazy(() =>
  import('@/pages/portal/challenge/ChallengeReportPage').then((module) => ({
    default: module.ChallengeReportPage,
  })),
);

export const ClassCheckoutPage = lazy(() =>
  import('@/pages/portal/ClassCheckoutPage').then((module) => ({
    default: module.ClassCheckoutPage,
  })),
);

export const AcademyCheckoutPage = lazy(() =>
  import('@/pages/portal/AcademyCheckoutPage').then((module) => ({
    default: module.AcademyCheckoutPage,
  })),
);

export const AcademyOrderPage = lazy(() =>
  import('@/pages/portal/AcademyOrderPage').then((module) => ({
    default: module.AcademyOrderPage,
  })),
);

export const AcademyPage = lazy(() =>
  import('@/pages/portal/AcademyPage').then((module) => ({ default: module.AcademyPage })),
);

export const AcademyProductDetailPage = lazy(() =>
  import('@/pages/portal/AcademyProductDetailPage').then((module) => ({
    default: module.AcademyProductDetailPage,
  })),
);

export const AcademySessionReportPage = lazy(() =>
  import('@/pages/portal/AcademySessionReportPage').then((module) => ({
    default: module.AcademySessionReportPage,
  })),
);

export const ClassesAndCoursesPage = lazy(() =>
  import('@/pages/portal/ClassesAndCoursesPage').then((module) => ({
    default: module.ClassesAndCoursesPage,
  })),
);

export const CourseDetailPage = lazy(() =>
  import('@/pages/portal/CourseDetailPage').then((module) => ({
    default: module.CourseDetailPage,
  })),
);

export const DashboardPage = lazy(() =>
  import('@/pages/portal/DashboardPage').then((module) => ({ default: module.DashboardPage })),
);

export const ExplorePage = lazy(() =>
  import('@/pages/portal/ExplorePage').then((module) => ({ default: module.ExplorePage })),
);

export const SchoolResearchPage = lazy(() =>
  import('@/pages/portal/SchoolResearchPage').then((module) => ({
    default: module.SchoolResearchPage,
  })),
);

export const PathwayNavigatorPage = lazy(() =>
  import('@/pages/portal/pathway/PathwayNavigatorPage').then((module) => ({
    default: module.PathwayNavigatorPage,
  })),
);

export const LegacyClassesRedirect = lazy(() =>
  import('@/pages/portal/LegacyClassesRedirect').then((module) => ({
    default: module.LegacyClassesRedirect,
  })),
);

export const GuidesPage = lazy(() =>
  import('@/pages/portal/guides/GuidesPage').then((module) => ({ default: module.GuidesPage })),
);

export const FamilyDetailPage = lazy(() =>
  import('@/pages/portal/FamilyDetailPage').then((module) => ({
    default: module.FamilyDetailPage,
  })),
);

export const KidGrowthPage = lazy(() =>
  import('@/pages/portal/KidGrowthPage').then((module) => ({ default: module.KidGrowthPage })),
);

export const StudySupportReportPage = lazy(() =>
  import('@/pages/portal/StudySupportReportPage').then((module) => ({
    default: module.StudySupportReportPage,
  })),
);

export const StudyPurchasePage = lazy(() =>
  import('@/pages/portal/StudyPurchasePage').then((module) => ({
    default: module.StudyPurchasePage,
  })),
);

export const KidProjectsPage = lazy(() =>
  import('@/pages/portal/KidProjectsPage').then((module) => ({ default: module.KidProjectsPage })),
);

export const MyProjectsPage = lazy(() =>
  import('@/pages/portal/MyProjectsPage').then((module) => ({ default: module.MyProjectsPage })),
);

export const PluginHostPage = lazy(() =>
  import('@/pages/portal/familyApps/PluginHostPage').then((module) => ({
    default: module.PluginHostPage,
  })),
);

export const MorePage = lazy(() =>
  import('@/pages/portal/MorePage').then((module) => ({ default: module.MorePage })),
);

export const KidCreatorPassportPage = lazy(() =>
  import('@/pages/portal/KidCreatorPassportPage').then((module) => ({
    default: module.KidCreatorPassportPage,
  })),
);

export const KidImagesPage = lazy(() =>
  import('@/pages/portal/KidImagesPage').then((module) => ({ default: module.KidImagesPage })),
);

export const FamilyNewPage = lazy(() =>
  import('@/pages/portal/FamilyNewPage').then((module) => ({ default: module.FamilyNewPage })),
);

export const PortalLoginPage = lazy(() =>
  import('@/pages/portal/LoginPage').then((module) => ({ default: module.LoginPage })),
);

export const RegisterPage = lazy(() =>
  import('@/pages/portal/RegisterPage').then((module) => ({ default: module.RegisterPage })),
);

export const SettingsPage = lazy(() =>
  import('@/pages/portal/SettingsPage').then((module) => ({ default: module.SettingsPage })),
);

export const TeacherDetailPage = lazy(() =>
  import('@/pages/portal/teachers/TeacherDetailPage').then((module) => ({
    default: module.TeacherDetailPage,
  })),
);

export const TutoringHubPage = lazy(() =>
  import('@/pages/portal/teachers/TutoringHubPage').then((module) => ({
    default: module.TutoringHubPage,
  })),
);

export const WalletPage = lazy(() =>
  import('@/pages/portal/WalletPage').then((module) => ({ default: module.WalletPage })),
);

export const WalletTopupPage = lazy(() =>
  import('@/pages/portal/WalletTopupPage').then((module) => ({ default: module.WalletTopupPage })),
);

export const StarsGuidePage = lazy(() =>
  import('@/pages/portal/StarsGuidePage').then((module) => ({ default: module.StarsGuidePage })),
);

export const WalletAutoTopupPage = lazy(() =>
  import('@/pages/portal/WalletAutoTopupPage').then((module) => ({
    default: module.WalletAutoTopupPage,
  })),
);

export const UsagePage = lazy(() =>
  import('@/pages/portal/UsagePage').then((module) => ({ default: module.UsagePage })),
);

export const DesktopDevicesPage = lazy(() =>
  import('@/pages/portal/desktop/DesktopDevicesPage').then((module) => ({
    default: module.DesktopDevicesPage,
  })),
);

export const DesktopPairPage = lazy(() =>
  import('@/pages/portal/desktop/DesktopPairPage').then((module) => ({
    default: module.DesktopPairPage,
  })),
);

export const KidUsagePage = lazy(() =>
  import('@/pages/portal/KidUsagePage').then((module) => ({ default: module.KidUsagePage })),
);

export const HscPlannerPage = lazy(() =>
  import('@/pages/portal/HscPlannerPage').then((module) => ({ default: module.HscPlannerPage })),
);

export const PromotionRewardsPage = lazy(() =>
  import('@/pages/portal/PromotionRewardsPage').then((module) => ({
    default: module.PromotionRewardsPage,
  })),
);

export const ClassCodePage = lazy(() =>
  import('@/pages/learn/ClassCodePage').then((module) => ({ default: module.ClassCodePage })),
);

export const TemporaryClassLoginPage = lazy(() =>
  import('@/pages/learn/TemporaryClassLoginPage').then((module) => ({
    default: module.TemporaryClassLoginPage,
  })),
);

export const LearnHomePage = lazy(() =>
  import('@/pages/learn/HomePage').then((module) => ({ default: module.HomePage })),
);

export const LearnLoginPage = lazy(() =>
  import('@/pages/learn/LoginPage').then((module) => ({ default: module.LoginPage })),
);

export const StudentSignupPage = lazy(() =>
  import('@/pages/learn/StudentSignupPage').then((module) => ({
    default: module.StudentSignupPage,
  })),
);

export const FamilyLinkAcceptPage = lazy(() =>
  import('@/pages/portal/FamilyLinkAcceptPage').then((module) => ({
    default: module.FamilyLinkAcceptPage,
  })),
);

// Independent student's own account (student-self-signup-prd.md §17, D-SSU-23).
export const StudentAccountLayout = lazy(() =>
  import('@/pages/learn/account/StudentAccountLayout').then((module) => ({
    default: module.StudentAccountLayout,
  })),
);

export const StudentAccountHomePage = lazy(() =>
  import('@/pages/learn/account/StudentAccountHomePage').then((module) => ({
    default: module.StudentAccountHomePage,
  })),
);

export const StudentAccountSettingsPage = lazy(() =>
  import('@/pages/learn/account/StudentAccountSettingsPage').then((module) => ({
    default: module.StudentAccountSettingsPage,
  })),
);

export const StudentStarsTopupPage = lazy(() =>
  import('@/pages/learn/student/StudentStarsTopupPage').then((module) => ({
    default: module.StudentStarsTopupPage,
  })),
);

export const KidHandoffPage = lazy(() =>
  import('@/pages/learn/KidHandoffPage').then((module) => ({ default: module.KidHandoffPage })),
);

export const LessonsCatalogPage = lazy(() =>
  import('@/pages/learn/LessonsCatalogPage').then((module) => ({
    default: module.LessonsCatalogPage,
  })),
);

export const PackLessonsPage = lazy(() =>
  import('@/pages/learn/PackLessonsPage').then((module) => ({ default: module.PackLessonsPage })),
);

export const LearnProfilePage = lazy(() =>
  import('@/pages/learn/ProfilePage').then((module) => ({ default: module.ProfilePage })),
);

export const ProjectDetailPage = lazy(() =>
  import('@/pages/learn/ProjectDetailPage').then((module) => ({
    default: module.ProjectDetailPage,
  })),
);

export const ProjectNewPage = lazy(() =>
  import('@/pages/learn/ProjectNewPage').then((module) => ({ default: module.ProjectNewPage })),
);

export const ProjectsListPage = lazy(() =>
  import('@/pages/learn/ProjectsListPage').then((module) => ({ default: module.ProjectsListPage })),
);

export const CreateHubPage = lazy(() =>
  import('@/pages/learn/create/CreateHubPage').then((module) => ({
    default: module.CreateHubPage,
  })),
);

export const LearnGalleryPage = lazy(() =>
  import('@/pages/learn/gallery/LearnGalleryPage').then((module) => ({
    default: module.LearnGalleryPage,
  })),
);

export const PortalGalleryPage = lazy(() =>
  import('@/pages/portal/PortalGalleryPage').then((module) => ({
    default: module.PortalGalleryPage,
  })),
);

export const CodeHubPage = lazy(() =>
  import('@/pages/learn/code/CodeHubPage').then((module) => ({ default: module.CodeHubPage })),
);

export const BlocksHubPage = lazy(() =>
  import('@/pages/learn/blocks/BlocksHubPage').then((module) => ({
    default: module.BlocksHubPage,
  })),
);

export const BlocksStudioRoutePage = lazy(() =>
  import('@/pages/learn/blocks/BlocksStudioRoutePage').then((module) => ({
    default: module.BlocksStudioRoutePage,
  })),
);

export const JourneyWestMapPage = lazy(() =>
  import('@/pages/learn/blocks/story-parts/JourneyWestMapPage').then((module) => ({
    default: module.JourneyWestMapPage,
  })),
);

export const JourneyWestPartRoute = lazy(() =>
  import('@/pages/learn/blocks/story-parts/JourneyWestPartPage').then((module) => ({
    default: module.JourneyWestPartRoute,
  })),
);

export const CodeStudioPage = lazy(() =>
  import('@/pages/learn/code/CodeStudioPage').then((module) => ({
    default: module.CodeStudioPage,
  })),
);

export const CodeRunPage = lazy(() =>
  import('@/pages/learn/code/CodeRunPage').then((module) => ({ default: module.CodeRunPage })),
);

export const ClassroomListPage = lazy(() =>
  import('@/pages/learn/classroom/ClassroomListPage').then((module) => ({
    default: module.ClassroomListPage,
  })),
);

export const ClassHubPage = lazy(() =>
  import('@/pages/learn/classroom/ClassHubPage').then((module) => ({
    default: module.ClassHubPage,
  })),
);

export const ClassGamesWallPage = lazy(() =>
  import('@/pages/learn/classroom/ClassGamesWallPage').then((module) => ({
    default: module.ClassGamesWallPage,
  })),
);

export const ClassPostPage = lazy(() =>
  import('@/pages/learn/classroom/ClassPostPage').then((module) => ({
    default: module.ClassPostPage,
  })),
);

export const WorkspacePage = lazy(() =>
  import('@/pages/learn/workspace/WorkspacePage').then((module) => ({
    default: module.WorkspacePage,
  })),
);

export const MusicStudioPage = lazy(() =>
  import('@/pages/learn/music/MusicStudioPage').then((module) => ({
    default: module.MusicStudioPage,
  })),
);

export const AcademyPracticePage = lazy(() =>
  import('@/pages/learn/academy/AcademyPracticePage').then((module) => ({
    default: module.AcademyPracticePage,
  })),
);

export const AcademyPreviewPage = lazy(() =>
  import('@/pages/learn/academy/AcademyPreviewPage').then((module) => ({
    default: module.AcademyPreviewPage,
  })),
);

export const AcademyProductPage = lazy(() =>
  import('@/pages/learn/academy/AcademyProductPage').then((module) => ({
    default: module.AcademyProductPage,
  })),
);

export const AcademyMockExamPage = lazy(() =>
  import('@/pages/learn/academy/AcademyMockExamPage').then((module) => ({
    default: module.AcademyMockExamPage,
  })),
);

// Self-paced courses (self-paced-courses-prd.md): own them, see the lessons, start one.
export const CoursesPage = lazy(() =>
  import('@/pages/learn/courses/CoursesPage').then((module) => ({
    default: module.CoursesPage,
  })),
);
export const CoursePage = lazy(() =>
  import('@/pages/learn/courses/CoursePage').then((module) => ({
    default: module.CoursePage,
  })),
);
export const MyExamPrepPage = lazy(() =>
  import('@/pages/learn/academy/MyExamPrepPage').then((module) => ({
    default: module.MyExamPrepPage,
  })),
);

export const HscPlanPage = lazy(() =>
  import('@/pages/learn/HscPlanPage').then((module) => ({ default: module.HscPlanPage })),
);

export const ChemicalEquationLabPage = lazy(() =>
  import('@/pages/learn/study/ChemicalEquationLabPage').then((module) => ({
    default: module.ChemicalEquationLabPage,
  })),
);

export const AlgebraMachinePage = lazy(() =>
  import('@/pages/learn/study/AlgebraMachinePage').then((module) => ({
    default: module.AlgebraMachinePage,
  })),
);

export const AnglesTrigonometryPage = lazy(() =>
  import('@/pages/learn/study/AnglesTrigonometryPage').then((module) => ({
    default: module.AnglesTrigonometryPage,
  })),
);

export const CoordinateDistancePage = lazy(() =>
  import('@/pages/learn/study/CoordinateDistancePage').then((module) => ({
    default: module.CoordinateDistancePage,
  })),
);

export const CoordinateTransformationsPage = lazy(() =>
  import('@/pages/learn/study/CoordinateTransformationsPage').then((module) => ({
    default: module.CoordinateTransformationsPage,
  })),
);

export const DataProbabilityPage = lazy(() =>
  import('@/pages/learn/study/DataProbabilityPage').then((module) => ({
    default: module.DataProbabilityPage,
  })),
);

export const FormulaLibraryPage = lazy(() =>
  import('@/pages/learn/study/FormulaLibraryPage').then((module) => ({
    default: module.FormulaLibraryPage,
  })),
);

export const FractionRatioLabPage = lazy(() =>
  import('@/pages/learn/study/FractionRatioLabPage').then((module) => ({
    default: module.FractionRatioLabPage,
  })),
);

export const FunctionsGraphsPage = lazy(() =>
  import('@/pages/learn/study/FunctionsGraphsPage').then((module) => ({
    default: module.FunctionsGraphsPage,
  })),
);

export const GeometryMeasurementPage = lazy(() =>
  import('@/pages/learn/study/GeometryMeasurementPage').then((module) => ({
    default: module.GeometryMeasurementPage,
  })),
);

export const IndicesPowersPage = lazy(() =>
  import('@/pages/learn/study/IndicesPowersPage').then((module) => ({
    default: module.IndicesPowersPage,
  })),
);

export const LogarithmExplorerPage = lazy(() =>
  import('@/pages/learn/study/LogarithmExplorerPage').then((module) => ({
    default: module.LogarithmExplorerPage,
  })),
);

export const MoneyModelsPage = lazy(() =>
  import('@/pages/learn/study/MoneyModelsPage').then((module) => ({
    default: module.MoneyModelsPage,
  })),
);

export const QuadraticSolverPage = lazy(() =>
  import('@/pages/learn/study/QuadraticSolverPage').then((module) => ({
    default: module.QuadraticSolverPage,
  })),
);

export const RatesCalculusPage = lazy(() =>
  import('@/pages/learn/study/RatesCalculusPage').then((module) => ({
    default: module.RatesCalculusPage,
  })),
);

export const SequencesGrowthPage = lazy(() =>
  import('@/pages/learn/study/SequencesGrowthPage').then((module) => ({
    default: module.SequencesGrowthPage,
  })),
);

export const SimultaneousEquationsPage = lazy(() =>
  import('@/pages/learn/study/SimultaneousEquationsPage').then((module) => ({
    default: module.SimultaneousEquationsPage,
  })),
);

export const MoleculeLabPage = lazy(() =>
  import('@/pages/learn/study/MoleculeLabPage').then((module) => ({
    default: module.MoleculeLabPage,
  })),
);

export const ChromatographyLabPage = lazy(() =>
  import('@/pages/learn/study/ChromatographyLabPage').then((module) => ({
    default: module.ChromatographyLabPage,
  })),
);

export const EquilibriumLabPage = lazy(() =>
  import('@/pages/learn/study/EquilibriumLabPage').then((module) => ({
    default: module.EquilibriumLabPage,
  })),
);

export const OrganicChemistryBuilderPage = lazy(() =>
  import('@/pages/learn/study/OrganicChemistryBuilderPage').then((module) => ({
    default: module.OrganicChemistryBuilderPage,
  })),
);

export const SpectroscopyDetectivePage = lazy(() =>
  import('@/pages/learn/study/SpectroscopyDetectivePage').then((module) => ({
    default: module.SpectroscopyDetectivePage,
  })),
);

export const PHTitrationLabPage = lazy(() =>
  import('@/pages/learn/study/PHTitrationLabPage').then((module) => ({
    default: module.PHTitrationLabPage,
  })),
);

export const IonicEquationLabPage = lazy(() =>
  import('@/pages/learn/study/IonicEquationLabPage').then((module) => ({
    default: module.IonicEquationLabPage,
  })),
);

export const MatterChangeLabPage = lazy(() =>
  import('@/pages/learn/study/MatterChangeLabPage').then((module) => ({
    default: module.MatterChangeLabPage,
  })),
);

export const ReactionPredictorPage = lazy(() =>
  import('@/pages/learn/study/ReactionPredictorPage').then((module) => ({
    default: module.ReactionPredictorPage,
  })),
);

export const ReactionRateLabPage = lazy(() =>
  import('@/pages/learn/study/ReactionRateLabPage').then((module) => ({
    default: module.ReactionRateLabPage,
  })),
);

export const RedoxLabPage = lazy(() =>
  import('@/pages/learn/study/RedoxLabPage').then((module) => ({ default: module.RedoxLabPage })),
);

export const StoichiometryLabPage = lazy(() =>
  import('@/pages/learn/study/StoichiometryLabPage').then((module) => ({
    default: module.StoichiometryLabPage,
  })),
);

export const StudyHomePage = lazy(() =>
  import('@/pages/learn/study/StudyHomePage').then((module) => ({ default: module.StudyHomePage })),
);

export const PeriodicTablePage = lazy(() =>
  import('@/pages/learn/study/PeriodicTablePage').then((module) => ({
    default: module.PeriodicTablePage,
  })),
);

export const CircuitsPage = lazy(() =>
  import('@/pages/learn/study/CircuitsPage').then((module) => ({ default: module.CircuitsPage })),
);

export const BiologyToolPage = lazy(() =>
  import('@/pages/learn/study/BiologyToolPage').then((module) => ({
    default: module.BiologyToolPage,
  })),
);

export const EarthScienceToolPage = lazy(() =>
  import('@/pages/learn/study/EarthScienceToolPage').then((module) => ({
    default: module.EarthScienceToolPage,
  })),
);

export const EnergyTransferPage = lazy(() =>
  import('@/pages/learn/study/EnergyTransferPage').then((module) => ({
    default: module.EnergyTransferPage,
  })),
);

export const ProjectileMotionPage = lazy(() =>
  import('@/pages/learn/study/ProjectileMotionPage').then((module) => ({
    default: module.ProjectileMotionPage,
  })),
);

export const LightRefractionPage = lazy(() =>
  import('@/pages/learn/study/LightRefractionPage').then((module) => ({
    default: module.LightRefractionPage,
  })),
);

export const PhysicsDomainPage = lazy(() =>
  import('@/pages/learn/study/PhysicsDomainPage').then((module) => ({
    default: module.PhysicsDomainPage,
  })),
);

export const HalfLifePage = lazy(() =>
  import('@/pages/learn/study/HalfLifePage').then((module) => ({ default: module.HalfLifePage })),
);

export const MotionGraphLabPage = lazy(() =>
  import('@/pages/learn/study/MotionGraphLabPage').then((module) => ({
    default: module.MotionGraphLabPage,
  })),
);

export const PhysicsFormulasPage = lazy(() =>
  import('@/pages/learn/study/PhysicsFormulasPage').then((module) => ({
    default: module.PhysicsFormulasPage,
  })),
);

export const VectorsForcesPage = lazy(() =>
  import('@/pages/learn/study/VectorsForcesPage').then((module) => ({
    default: module.VectorsForcesPage,
  })),
);

export const WavesLabPage = lazy(() =>
  import('@/pages/learn/study/WavesLabPage').then((module) => ({ default: module.WavesLabPage })),
);

export const StudyReviewPage = lazy(() =>
  import('@/pages/learn/study/StudyReviewPage').then((module) => ({
    default: module.StudyReviewPage,
  })),
);

export const StudyMaterialsLibraryPage = lazy(() =>
  import('@/pages/learn/study/StudyMaterialsLibraryPage').then((module) => ({
    default: module.StudyMaterialsLibraryPage,
  })),
);

export const StudyMaterialAnalysisPage = lazy(() =>
  import('@/pages/learn/study/StudyMaterialAnalysisPage').then((module) => ({
    default: module.StudyMaterialAnalysisPage,
  })),
);

export const StudySessionPage = lazy(() =>
  import('@/pages/learn/study/StudySessionPage').then((module) => ({
    default: module.StudySessionPage,
  })),
);

export const StudySubjectPage = lazy(() =>
  import('@/pages/learn/study/StudySubjectPage').then((module) => ({
    default: module.StudySubjectPage,
  })),
);

// Study Mind map editor (study-mind-map-prd.md §4). React Flow loads only with this page.
export const StudyMindMapEditorPage = lazy(() =>
  import('@/pages/learn/study/StudyMindMapEditorPage').then((module) => ({
    default: module.StudyMindMapEditorPage,
  })),
);

export const StudyToolsHubPage = lazy(() =>
  import('@/pages/learn/study/StudyToolsHubPage').then((module) => ({
    default: module.StudyToolsHubPage,
  })),
);

export const StudySubjectsPage = lazy(() =>
  import('@/pages/learn/study/StudySubjectsPage').then((module) => ({
    default: module.StudySubjectsPage,
  })),
);

export const ChallengeSubmitPage = lazy(() =>
  import('@/pages/learn/challenge/ChallengeSubmitPage').then((module) => ({
    default: module.ChallengeSubmitPage,
  })),
);

export const CreatorPassportPage = lazy(() =>
  import('@/pages/learn/CreatorPassportPage').then((module) => ({
    default: module.CreatorPassportPage,
  })),
);

export const ClassDashboardPage = lazy(() =>
  import('@/pages/teacher/ClassDashboardPage').then((module) => ({
    default: module.ClassDashboardPage,
  })),
);

export const LiveViewPage = lazy(() =>
  import('@/pages/teacher/LiveViewPage').then((module) => ({ default: module.LiveViewPage })),
);

export const TeacherProjectLivePage = lazy(() =>
  import('@/pages/teacher/TeacherProjectLivePage').then((module) => ({
    default: module.TeacherProjectLivePage,
  })),
);

export const TeacherSurfaceHandoffPage = lazy(() =>
  import('@/pages/teacher/TeacherSurfaceHandoffPage').then((module) => ({
    default: module.TeacherSurfaceHandoffPage,
  })),
);

export const TeacherPrepStudioPage = lazy(() =>
  import('@/pages/teacher/TeacherPrepStudioPage').then((module) => ({
    default: module.TeacherPrepStudioPage,
  })),
);

export const AssessmentPage = lazy(() =>
  import('@/pages/teacher/AssessmentPage').then((module) => ({ default: module.AssessmentPage })),
);

export const ArtStudioPage = lazy(() =>
  import('@/pages/learn/create/art/ArtStudioPage').then((module) => ({
    default: module.ArtStudioPage,
  })),
);

export const ArtHubPage = lazy(() =>
  import('@/pages/learn/create/art/ArtHubPage').then((module) => ({ default: module.ArtHubPage })),
);

export const VoiceBoothPage = lazy(() =>
  import('@/pages/learn/create/VoiceBoothPage').then((module) => ({
    default: module.VoiceBoothPage,
  })),
);

export const VideoStudioPage = lazy(() =>
  import('@/pages/learn/create/VideoStudioPage').then((module) => ({
    default: module.VideoStudioPage,
  })),
);

export const VideoStudioWorkspacePage = lazy(() =>
  import('@/pages/learn/video-studio/VideoStudioWorkspacePage').then((module) => ({
    default: module.VideoStudioWorkspacePage,
  })),
);

export const PublicPlayPage = lazy(() =>
  import('@/pages/play/PublicPlayPage').then((module) => ({ default: module.PublicPlayPage })),
);

export const SubmissionPlayPage = lazy(() =>
  import('@/pages/challenge-review/SubmissionPlayPage').then((module) => ({
    default: module.SubmissionPlayPage,
  })),
);

export const TryBlocksPage = lazy(() =>
  import('@/pages/try/TryBlocksPage').then((module) => ({ default: module.TryBlocksPage })),
);

export const TryPlaygroundPage = lazy(() =>
  import('@/pages/try/TryPlaygroundPage').then((module) => ({ default: module.TryPlaygroundPage })),
);

export const TryArtPage = lazy(() =>
  import('@/pages/try/TryArtPage').then((module) => ({ default: module.TryArtPage })),
);

export const TryMusicPage = lazy(() =>
  import('@/pages/try/TryMusicPage').then((module) => ({ default: module.TryMusicPage })),
);

export const TryVideoPage = lazy(() =>
  import('@/pages/try/TryVideoPage').then((module) => ({ default: module.TryVideoPage })),
);

export const SiblingDiscountDemoPage = lazy(() =>
  import('@/pages/try/SiblingDiscountDemoPage').then((module) => ({
    default: module.SiblingDiscountDemoPage,
  })),
);

export const MathToolDemoPage = lazy(() =>
  import('@/pages/try/MathToolDemoPage').then((module) => ({ default: module.MathToolDemoPage })),
);

export const PublicVotePage = lazy(() =>
  import('@/pages/vote/PublicVotePage').then((module) => ({ default: module.PublicVotePage })),
);

export const JourneyToWestC1PreviewPage = lazy(() =>
  import('@/pages/experiments/JourneyToWestC1PreviewPage').then((module) => ({
    default: module.JourneyToWestC1PreviewPage,
  })),
);

export const CampaignExperiencePage = lazy(() =>
  import('@/pages/campaigns/CampaignExperiencePage').then((module) => ({
    default: module.CampaignExperiencePage,
  })),
);

export const SelfPacedCoursesPage = lazy(() =>
  import('@/pages/portal/selfpaced/SelfPacedCoursesPage').then((module) => ({
    default: module.SelfPacedCoursesPage,
  })),
);

export const SelfPacedCoursePage = lazy(() =>
  import('@/pages/portal/selfpaced/SelfPacedCoursePage').then((module) => ({
    default: module.SelfPacedCoursePage,
  })),
);

export const SeniorPathwayPage = lazy(() =>
  import('@/pages/portal/senior-pathway/SeniorPathwayPage').then((module) => ({
    default: module.SeniorPathwayPage,
  })),
);
